module.exports = __webpack_public_path__ + "img/linked-drawings-and-specs.bc920396.png";